import * as R from 'ramda';

import LocalLogger from './LocalLogger';
import { Logger } from './logger';
import NullLogger from './NullLogger';

export default class Log {
  static currentLogger: Logger = new NullLogger();

  static debug(message: string, ...optionalParams: unknown[]): void {
    Log.currentLogger.debug(message, optionalParams);
  }

  static error(message: string, error: Error | null = null, ...optionalParams: unknown[]): void {
    Log.currentLogger.error(message, error, optionalParams);
  }

  static initializeLogger(): void {
    const stage = (process.env.REACT_APP_STAGE || 'unknown').toLowerCase();
    if (R.contains(stage, ['dev', 'preprod', 'e2e'])) {
      Log.currentLogger = new LocalLogger();
    } else {
      Log.currentLogger = new NullLogger();
    }
  }
}

Log.initializeLogger();
